import { useTranslation } from 'react-i18next';

const trends = [
  { titleKey: 'butlerSchool.global.1.title', descKey: 'butlerSchool.global.1.desc', icon: 'ri-building-4-line' },
  { titleKey: 'butlerSchool.global.2.title', descKey: 'butlerSchool.global.2.desc', icon: 'ri-clipboard-line' },
  { titleKey: 'butlerSchool.global.3.title', descKey: 'butlerSchool.global.3.desc', icon: 'ri-earth-line' },
  { titleKey: 'butlerSchool.global.4.title', descKey: 'butlerSchool.global.4.desc', icon: 'ri-shield-keyhole-line' },
];

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).filter((part) => part.length > 0).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function GlobalDirection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {renderParagraphs(
            t('butlerSchool.global.label'),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerSchool.global.title')}
          </h2>
          {renderParagraphs(
            t('butlerSchool.global.subtitleEn'),
            'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4',
          )}
          <div className="gold-line mx-auto mb-6"></div>
          {renderParagraphs(
            t('butlerSchool.global.lead'),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[680px] mx-auto',
          )}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-2 border border-accent-500/20 pointer-events-none hidden md:block"></div>
              <img
                src="/images/generated/hotel-scenario-1.jpg"
                alt={t('butlerSchool.global.imgAlt')}
                className="relative w-full aspect-[4/3] object-cover object-center"
                loading="lazy"
              />
            </div>
            {renderParagraphs(
              t('butlerSchool.global.caption'),
              'text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mt-5',
            )}
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {trends.map((trend) => (
              <div
                key={trend.titleKey}
                className="card-glow bg-background-50 border border-background-200/60 p-6 flex flex-col items-start cursor-default"
              >
                <div className="w-11 h-11 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center mb-4">
                  <i className={`${trend.icon} text-accent-500 text-lg`}></i>
                </div>
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] leading-[1.6] mb-3">
                  {t(trend.titleKey)}
                </h3>
                {renderParagraphs(
                  t(trend.descKey),
                  'text-[16px] text-foreground-600 tracking-[0.03em] leading-[1.95]',
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
